import { render, staticRenderFns } from "./AirtimeComponent.vue?vue&type=template&id=a0a7fa3e&"
import script from "./AirtimeComponent.vue?vue&type=script&lang=js&"
export * from "./AirtimeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports